import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BuildingComponent } from './building/building.component';
import { NsideIdentityGuard } from '../shared/services/auth/nSideIdentityGuard';
import { RedirectComponent } from './redirect/redirect.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SilentRenewComponent } from './silent-renew/silent-renew.component';
import { LogoutComponent } from './logout/logout.component';
import { NotFoundComponent } from './not-found/not-found.component';

export const routes: Routes = [
    { 
        path: '', 
        redirectTo: 'dashboard', 
        pathMatch: 'full'
    },
    { 
        path: 'tips-queue/:buildingId/hasAssess/:hasAssess/canAssess/:userAssessPermission/region/:regionId', 
        component: BuildingComponent, 
        canActivate: [NsideIdentityGuard] 
    },
    { 
        path: 'dashboard', 
        component: DashboardComponent, 
        canActivate: [NsideIdentityGuard] 
    },
    {
        path: 'redirect',
        component: RedirectComponent,
        data: { showSidebar: false }
    },
    {
        path: 'unauthorized',
        component: SpinnerComponent,
        data: { showSidebar: false }
    },
    {
        path: 'silent-renew',
        component: SilentRenewComponent,
        data: { showSidebar: false }
    },
    {
        path: 'logout',
        component: LogoutComponent,
        data: { showSidebar: false }
    },
    { 
        path: '**', 
        component: NotFoundComponent,
        data: { showSidebar: false } 
    }
];
